import {
  mdiAccount,
  mdiAccountGroup,
  mdiShieldCheck,
  mdiFileDocumentMultiple,
  mdiSecurity,
} from "@mdi/js";

import { Menu, SideBarMenu } from "@/shared/models/menu.model";

export const EMPLOYEE_BENEFIT_MENU: SideBarMenu = {
  text: "Employee Benefit",
  name: "employee-benefit",
  icon: mdiAccount,
  group: "employee-benefit",
  items: [],
};

export const EMPLOYEE_LIST_MENU: Menu = {
  text: "Participant List",
  name: "employee",
  icon: mdiAccountGroup,
};

export const PLAN_LIST_MENU: Menu = {
  text: "Plan List",
  name: "plan",
  icon: mdiShieldCheck,
};

export const BENEFIT_LIST_MENU: Menu = {
  text: "Benefit Package",
  name: "benefit",
  icon: mdiFileDocumentMultiple,
};

export const POLICY_LIST_MENU: Menu = {
  text: "Policy List",
  name: "policy",
  icon: mdiSecurity,
};
